<div class="boq-params">
  <header>
    <h2>Chainage &amp; section</h2>
    <p>Length × width × thickness</p>
  </header>

  <label class="field">
    <span>LRS route</span>
    <select [ngModel]="wb.routeId" (ngModelChange)="onRouteChange($event)">
      <option [ngValue]="null">Select route</option>
      <option *ngFor="let r of wb.routes" [ngValue]="r.id">
        {{ r.route_code }} · {{ r.route_name }}
      </option>
    </select>
  </label>

  <div class="field-row">
    <label class="field">
      <span>Start</span>
      <input type="text" [(ngModel)]="wb.startChainage" (ngModelChange)="onChainageChange()" placeholder="0+000" />
    </label>
    <label class="field">
      <span>End</span>
      <input type="text" [(ngModel)]="wb.endChainage" (ngModelChange)="onChainageChange()" placeholder="1+000" />
    </label>
  </div>

  <label class="field">
    <span>Lane / carriageway width (m)</span>
    <input type="number" step="0.1" min="0" [(ngModel)]="wb.laneWidthM" (ngModelChange)="onWidthChange()" />
  </label>

  <label class="field">
    <span>Shoulder width (m)</span>
    <input type="number" step="0.1" min="0" [(ngModel)]="wb.shoulderWidthM" (ngModelChange)="onWidthChange()" />
  </label>
  <p class="hint">First 1.5 m is paved (WMM + seal, MoRTH 406); remainder is earthen fill (MoRTH 305).</p>

  <label class="field">
    <span>Median</span>
    <select [ngModel]="wb.median" (ngModelChange)="onMedianChange($event)">
      <option value="concrete">Concrete</option>
      <option value="none">None</option>
    </select>
  </label>

  <button type="button" class="recalc" (click)="wb.recalculate()" [disabled]="wb.loading">
    {{ wb.loading ? 'Calculating…' : 'Recalculate' }}
  </button>

  <p class="hint" *ngIf="wb.lengthKm">Span {{ wb.lengthKm }} km</p>
  <p class="err" *ngIf="wb.error">{{ wb.error }}</p>
</div>
